function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
}

const saved = getCookie('cookie_consent');

const state = {
  show: saved === null,
  accepted: saved === 'accepted'
}

const getters = {
  show(state, _getters, _rootState) {
    return state.show;
  },
  accepted(state, _getters, _rootState) {
    return state.accepted;
  },
}

const mutations = {
  setShow(state, value) {
    state.show = value
  },
  setAccepted(state, value) {
    state.accepted = value
    setCookie('cookie_consent', value ? 'accepted' : 'declined', 365);
  },
}



const cookieConsent = {
  namespaced: true,
  state,
  mutations,
  getters
}

export default cookieConsent;